/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { ListItem, Col, Row } from "@deere/ux.uxframe-react";
import "../assets/css/SearchPage.css";
import { useHistory } from 'react-router'
import { getDateFromTimeStamp } from '../utils/utils'
import { Container } from "@deere/ux.uxframe-react/lib/components/Container";
import { getSurveyById } from '../services/survey.service';
import { getDetailSurveyResponse } from '../services/survey.service';
import { getCampaigsByRn } from '../services/campaign.service';
import { useDispatch } from 'react-redux'
import { setSurveyResponse } from '../redux/action/surveyAction';
import { updateGenResponse } from '../redux/action/genericSurveyAction';
import { setCampaign } from '../redux/action/campaignAction'
import { SCBM_CODE, SCBM_INDIRECT, CM, EM, CRS_REQUEST_STATUS_OBJ, TPS, ST, COO, TPSMEX, AEU, CRS_SURVEY_TEMPLATES } from '../utils/surveyLiterals'
import { Contacts } from "./Contacts";
import { isUserAnAdminOfSurvey } from "../utils/utils";
import { useUserInfo } from "../providers/userProvider";
import { getRequestStatusWhenCampaignClosed } from "../utils/utils";

export const RequestListItem = ({ item, authState }) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const userInfo = useUserInfo();
    const [redirect, setRedirect] = useState(false)

    const fetchDetailsSurveyRes = async () => {
        return getDetailSurveyResponse(item.campaignid, item.supplierNo, authState.accessToken.accessToken)
            .then((res) => {
                if (res)
                    item.surveyCode === SCBM_CODE || item.surveyCode === SCBM_INDIRECT? dispatch(setSurveyResponse(res)) : dispatch(updateGenResponse({ surveyCode: item.surveyCode, surveyResponse: res }))
                return res

            }).catch(error => {
                console.log(error);
            })
    }

    const fetchCampaignByRn = async () => {
        return getCampaigsByRn(item.id, authState.accessToken.accessToken)
            .then((res) => {
                if (res){
                    dispatch(setCampaign(res));
                }
                return res
            }).catch(error => {
                console.log(error);
            })
    }

    const fetchSurveyById = async () => {
        return getSurveyById(item.surveyId, authState.accessToken.accessToken)    
            .then((survey) => {
                history.push({
                    pathname: '/review',
                    state: {
                        previous: '/',
                        survey: survey ? survey : {},
                        updatedByName: item ? item.updatedByName ? item.updatedByName : item.updatedBy : '',
                        supplierName: item ? item.supplierName : '',
                        surveyType: survey ? survey.description : '',                       
                        updatedTs: item.updatedts,
                        status: item.status,                    
                        campaign:item
                    }
                })
            }).catch(err => { throw err })
    }
    function openReviewScreen(e) {
        e.preventDefault();
        setRedirect(true)
        fetchDetailsSurveyRes();
        fetchCampaignByRn();
        fetchSurveyById();
    };

    function redirectTo(e){
        if (item.templateType === CRS_SURVEY_TEMPLATES.PART) {
            history.push({
                pathname: `/surveypart?rn=${item.id}`,
                state: {
                    previous: '/'
                }
            })
        } else {
            switch (item.surveyCode) {
                case CM:
                    history.push({
                        pathname: `/cm?rn=${item.id}`,
                        state: {
                            previous: '/'                   
                        }
                    })
                    return;
                case EM:
                    history.push({
                        pathname: `/em?rn=${item.id}`,
                        state: {
                            previous: '/'                   
                        }
                    })
                    return;
                case TPS:
                case TPSMEX:
                    history.push({
                        pathname: `/tps?rn=${item.id}`,
                        state: {
                            previous: '/'                   
                        }
                    })
                    return;
                case COO:
                    history.push({
                        pathname: `/coo?rn=${item.id}`,
                        state: {
                            previous: '/'
                        }
                    })
                    return;
                case ST:
                    openScreenBasedOnAdminRole(e)
                    return;
                case AEU:
                    history.push({
                        pathname: `/survey?rn=${item.id}`,
                        state: {
                            previous: '/'                   
                        }
                    })
                    return;    
                default:
                    openReviewScreen(e) 
                    break;
            }
        }
    }

    function openScreenBasedOnAdminRole(e){
        e.preventDefault();
        setRedirect(true);
        getSurveyById(item.surveyId, authState.accessToken.accessToken)    
        .then((survey) => {
            let pathName = '/streview'
            if(isUserAnAdminOfSurvey(userInfo.roles, survey.adminRole)){
                pathName = `/st`
            }
            history.push({
                pathname: pathName,
                state: {
                    previous: '/',
                    surveyType: item.surveyType,
                    supplierName: `${item.supplierNo} - ${item.supplierName}`,
                    queryParam: item.id,
                    isAdmin: true,
                    surveyCode: item.surveyCode,
                    endDate: item.endDate? item.endDate:'',
                    campaign: item
                }
            })
        }).catch(err => { throw err })
    }

    function submittedBy(tmpRequest){
        return tmpRequest.updatedByName ? tmpRequest.updatedByName : tmpRequest.updatedBy;
    }
    
    let contactItems = item && item.deereContactName ? item.deereContactName : [];
    if(item && item.isNonDeere){
        contactItems = item && item.companyContactName ? item.companyContactName : [];
    }

    return (
        <ListItem className="list-group-item mb-1">
            <Container>
                <Row>
                    <Col>
                        <span>
                            <span>
                                {
                                    redirect ? 'Redirecting ...' : <a href="" onClick={redirectTo}>{item ? `# ${item.id} - ` : ''} {item.surveyType}</a>
                                }
                            </span>
                        </span>
                        <div className="d-flex w-100 justify-content-between">
                            <span>
                                <span className="mr-2 font-weight-bold">Supplier</span>
                                <span>
                                    {item ? `${item.supplierNo ? item.supplierNo : ''} - ${item.supplierName ? item.supplierName : ''}` : ''}
                                </span>
                            </span>
                        </div>
                        <div className="d-flex w-100 justify-content-between">
                            <span>
                                <Contacts items={contactItems} isNonDeere={item.isNonDeere}/>
                            </span>
                        </div>
                        <div className="d-flex w-100 justify-content-between">
                            <span>
                                <span className="mr-2 font-weight-bold">Submitted By</span>
                                <span>{item && item.status===CRS_REQUEST_STATUS_OBJ.COMPLETE? submittedBy(item) : ''}</span>
                            </span>
                        </div>
                    </Col>
                    <Col xs={7}>
                        <div className="d-flex w-100 justify-content-between">
                            <span>
                                <span className="mr-2 font-weight-bold">Status</span>
                                <span>{item ? getRequestStatusWhenCampaignClosed(item.status, item.campaignstatus) : ""}</span>
                            </span>
                        </div>
                        <div className="d-flex w-100 justify-content-between">
                            <span>
                                <span className="mr-2 font-weight-bold">Due date</span>
                                <span>{item ? getDateFromTimeStamp(item.endDate) : ''}</span>
                            </span>
                        </div>
                    </Col>
                </Row>
            </Container>
        </ListItem>
    );
};
